// PreventiApp — SmartHome
// Punto de entrada inteligente para usuarios autenticados en app.preventiapp.com.
// Decide a qué panel llevar al usuario según su rol:
//   - super_admin_inside / es_inside_staff  → /admin
//   - admin_colegio                          → /admin
//   - roles operativos (docente, inspector,
//     orientador, encargado_convivencia,
//     directivo)                             → App móvil (MobileApp)
//
// RequireAuth ya asegura que sólo llegan aquí usuarios con sesión activa.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MobileApp from '../mobile/MobileApp';

const ADMIN_ROLES = new Set(['super_admin_inside', 'admin_colegio']);

export default function SmartHome() {
  const { profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#0B1B5E]" data-testid="smart-home-loading">
        Cargando…
      </div>
    );
  }

  // Sin perfil aún: mostramos la app operativa por defecto (segura).
  if (!profile) return <MobileApp />;

  if (profile.es_inside_staff === true || ADMIN_ROLES.has(profile.rol)) {
    return <Navigate to="/admin" replace />;
  }

  return <MobileApp />;
}
